export default "__VITE_ASSET__406043cd__"